import {FDS_SUCCESS_SUB_PATH} from './constants'
import {RouterPath} from './utils'

const ORDER_SHEET_ROOT = '/ordersheet'
const SELLER_ROOT = `${ORDER_SHEET_ROOT}/seller`
const SELLER_RESULT = `${SELLER_ROOT}/result`
const SELLER_POPUP = `${SELLER_ROOT}/popup`
const FAMILY_ROOT = `${ORDER_SHEET_ROOT}/familyPay`

const OrderSheet = RouterPath.create(ORDER_SHEET_ROOT)
const Booking = RouterPath.create(OrderSheet, 'booking')
const Subscription = RouterPath.create(OrderSheet, 'subscription')

export type RoutersCheckoutPathGroup = {
    CHECK_OUT: RouterPath
    APPLY: RouterPath
    FAIL: RouterPath
}

const makeCheckoutPathGroup = (route: RouterPath, path?: string): RoutersCheckoutPathGroup => {
    const checkout = RouterPath.create(route, path)
    return {
        CHECK_OUT: checkout,
        /** 주문승인 */
        APPLY: RouterPath.create(checkout, `apply`),
        /** 주문실패 */
        FAIL: RouterPath.create(checkout, `fail`),
    }
}

export const ROUTER_ORDER_SHEET = {
    MAIN: makeCheckoutPathGroup(OrderSheet),
    /** 주문서 */
    MALL: makeCheckoutPathGroup(OrderSheet, `mall`),
    EASY_BOOKING: makeCheckoutPathGroup(OrderSheet, `easybooking`),
    LOCAL_PAY: makeCheckoutPathGroup(OrderSheet, `localpay`),
    BLOG: makeCheckoutPathGroup(OrderSheet, `blog`),
    // 추후에 경로 통합
    SELLER: makeCheckoutPathGroup(OrderSheet, `seller`),
    FAMILY_PAY: makeCheckoutPathGroup(OrderSheet, `familyPay`),
    FLEA_MARKET: makeCheckoutPathGroup(OrderSheet, `fleamarket`),
}

export const ROUTER_ORDER_SHEET_SELLER = {
    MAIN: SELLER_ROOT,
    /** 주문하기 */
    CHECKOUT: `${SELLER_ROOT}`,
    CHECKOUT_APPLY: {
        MAIN: `${SELLER_ROOT}/apply`,
        SHOPN: `${SELLER_ROOT}/apply/shopn`,
        GIFTING: `${SELLER_ROOT}/apply/gifting`,
        BRANCH: `${SELLER_ROOT}/apply/branch`,
    },
    CHECKOUT_FAIL: {
        MAIN: `${SELLER_ROOT}/fail`,
        SHOPN: `${SELLER_ROOT}/fail/shopn`,
        GIFTING: `${SELLER_ROOT}/fail/gifting`,
        BRANCH: `${SELLER_ROOT}/fail/branch`,
    },
    /** FDS 결과 연동 */
    FDS_AUTH_BRIDGE: `${SELLER_ROOT}/fds/auth`,
    /** 주문결과 */
    RESULT: SELLER_RESULT,
    POP_UP: {
        MAIN: `${SELLER_POPUP}`,
        BRIDGE: `${SELLER_POPUP}/bridge`,
        CANCEL_MOBILE_PIN: `${SELLER_POPUP}/pinPayPassClose`,
        CHANGE_MOBILE_PIN: `${SELLER_POPUP}/pinPayPassChange`,
        NON_PURCHASABLE: `${SELLER_POPUP}/nonPurchasable`,
        FIRST_DELIVERY_SEARCH: `${SELLER_POPUP}/firstDeliverySearch`,
        FIRST_DELIVERY_FORM: `${SELLER_POPUP}/firstDeliveryForm`,
    },
    /** 배송지 관리 */
    DELIVERY: `${SELLER_ROOT}/delivery`,
    /** 수령위치/출입방법 */
    DELIVERY_INSTRUCTION: `${SELLER_ROOT}/deliveryInstruction`,
}

export const ROUTER_ORDER_SHEET_FAMILY_PAY = {
    ROOT: FAMILY_ROOT,
    /** 패밀리 결제 승인 주문서 */
    CHECKOUT: FAMILY_ROOT,
    /** 패밀리 결제 승인 요청 */
    APPLY: `${FAMILY_ROOT}/apply`,
    /** 패밀리 결제 승인 실패 */
    FAIL: `${FAMILY_ROOT}/fail`,
    /** 구매불가 */
    NON_PURCHASABLE: `${FAMILY_ROOT}/popup/nonPurchasable`,
    /** 패밀리 결제 외부 결과 연동 */
    POP_UP_BRIDGE: `${FAMILY_ROOT}/popup/bridge`,
    /** FDS 결과 연동 */
    FDS_AUTH_BRIDGE: `${FAMILY_ROOT}/fds/auth`,
    /** 패밀리 결제 완료 */
    RESULT: `${FAMILY_ROOT}/result`,
}

/** 예약주문 자동결제  */
export const ROUTER_ORDER_SHEET_BOOKING = {
    ROOT: Booking,
    FDS_AUTH_BRIDGE: RouterPath.create(Booking, '/fds'),
    FDS_AUTH_APPLYING_BRIDGE: RouterPath.create(Booking, `/fds/${FDS_SUCCESS_SUB_PATH}`),
}
/** 정기구독 */
export const ROUTER_ORDER_SHEET_SUBSCRIPTION = {
    ROOT: Subscription,
    DELIVERY_INSTRUCTION: RouterPath.create(Subscription, '/deliveryInstruction'),
}
